import { Font } from "./types/Font";

export const dmSansFont = new Font("DM Sans", "'DM Sans', sans-serif", [
  {
    fontStyle: "normal",
    fontWeight: "400",
    fontDisplay: "swap",
    sources: [
      {
        src: "url('https://fonts.gstatic.com/s/dmsans/v15/rP2Yp2ywxg089UriI5-g7M8btVsD8Ck0q7u6-K6z9mXgjU0.woff2') format('woff2')",
        unicodeRange:
          "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF",
      },
      {
        src: "url('https://fonts.gstatic.com/s/dmsans/v15/rP2Yp2ywxg089UriI5-g7M8btVsD8Ck0q7u0-K6z9mXg.woff2') format('woff2')",
        unicodeRange:
          "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
      },
    ],
  },
  {
    fontStyle: "italic",
    fontWeight: "400",
    fontDisplay: "swap",
    sources: [
      {
        src: "url('https://fonts.gstatic.com/s/dmsans/v15/rP2Wp2ywxg089UriCZaSExdy3sGt9zz86GPwyKK58UfivUw4aw.woff2') format('woff2')",
        unicodeRange:
          "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF",
      },
      {
        src: "url('https://fonts.gstatic.com/s/dmsans/v15/rP2Wp2ywxg089UriCZaSExdy3sGt9zz86GPwyKy58UfivUw.woff2') format('woff2')",
        unicodeRange:
          "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
      },
    ],
  },
  {
    fontStyle: "normal",
    fontWeight: "600",
    fontDisplay: "swap",
    sources: [
      {
        src: "url('https://fonts.gstatic.com/s/dmsans/v15/rP2Yp2ywxg089UriI5-g7M8btVsD8CnTrLu6-K6z9mXgjU0.woff2') format('woff2')",
        unicodeRange:
          "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF",
      },
      {
        src: "url('https://fonts.gstatic.com/s/dmsans/v15/rP2Yp2ywxg089UriI5-g7M8btVsD8CnTrLu0-K6z9mXg.woff2') format('woff2')",
        unicodeRange:
          "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
      },
    ],
  },
  {
    fontStyle: "italic",
    fontWeight: "600",
    fontDisplay: "swap",
    sources: [
      {
        src: "url('https://fonts.gstatic.com/s/dmsans/v15/rP2Wp2ywxg089UriCZaSExdy3sGt9zz86IT3yKK58UfivUw4aw.woff2') format('woff2')",
        unicodeRange:
          "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF",
      },
      {
        src: "url('https://fonts.gstatic.com/s/dmsans/v15/rP2Wp2ywxg089UriCZaSExdy3sGt9zz86IT3yKy58UfivUw.woff2') format('woff2')",
        unicodeRange:
          "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
      },
    ],
  },
]);
